import React from "react";

import { Route, Routes } from "react-router-dom";

import RoleAccess from '../pages/admin/access/role';
import UserAccess from '../pages/admin/access/user';
import TunnelGre from '../pages/admin/prov_service/TunnelGRE'
import RoleAdmin from '../pages/admin/user/role';
import UserAdmin from '../pages/admin/user/user';
import Empresa from '../pages/admin/empresa';
import ProvService from '../pages/admin/prov_service/services';
import ProvOlt from '../pages/admin/prov_service/olts';
import ProvProxies from '../pages/admin/prov_service/proxies';
import OnuProvisioning from '../pages/admin/prov_service/OnuProvisioning';

import Log from '../pages/admin/prov_service/Log';
import LogAuditAdmin from '../pages/admin/logAudit';
import { RequireAuthAdmin } from "../components/AuthAdminProvider";
import NotFound from "../pages/NotFound";
import NotAuthorized from "../pages/NotAuthorized";
import MainFrame from "../components/MainFrame";
import BackupService from "../pages/admin/backup_service/services";
import { MenuAdmin } from '../pages/admin/Menu';
import License from "../pages/admin/licenses";
import Services from "../pages/admin/services";
import Backup from "../pages/admin/backup_service/Backup";
import Queue from "../pages/admin/backup_service/Queue";
// import ErrorBackup from "../pages/admin/backup_service/ErrorBackup";
import Host from "../pages/admin/backup_service/Host";
import Config from "../pages/admin/backup_service/Config";
import LogBackup from "../pages/admin/backup_service/Audit";
import HermesDashboard from "../pages/admin/backup_service/Dashboard";
import Profile from "../pages/admin/profile";
import SecuritySettings from "../pages/admin/profile/SecuritySettings";
import TroubleshootingSimple from "../pages/admin/troubleshooting_simple";
import TopologyPage from "../pages/admin/hermes/topology/TopologyPage";
import SnapshotPage from "../pages/admin/hermes/snapshot/SnapshotPage";
import SessaoPage from "../pages/admin/hermes/snapshot/SessaoPage";
import GruposHosts from "../pages/admin/hermes/snapshot/GruposHosts";
import CatalogoComandos from "../pages/admin/hermes/snapshot/CatalogoComandos";
import FilaSnapshot from "../pages/admin/hermes/snapshot/FilaSnapshot";

export default function AdminRoutes() {
    return (
        <>
            <Route path="/admin" element={
                <RequireAuthAdmin>
                    <MainFrame admin
                    menuComponent={<MenuAdmin/>}
                    />
                </RequireAuthAdmin>
            }>

                <Route path="/admin" element={<Empresa />} />
                <Route path="/admin/user" element={<UserAdmin />} />
                <Route path="/admin/user/role" element={<RoleAdmin />} />
                <Route path="/admin/access/role" element={<RoleAccess />} />
                <Route path="/admin/provisioning/log" element={<Log />} />
                <Route path="/admin/access/role" element={<RoleAccess />} />
                <Route path="/admin/access/user" element={<UserAccess />} />
                <Route path="/admin/empresa" element={<Empresa />} />
                <Route path="/admin/provisioning/service" element={<ProvService />} />
                <Route path="/admin/provisioning/olt" element={<ProvOlt />} />
                <Route path="/admin/provisioning/proxy" element={<ProvProxies />} />
                <Route path='/admin/audit' element={<LogAuditAdmin />} />
                <Route path="/admin/provisioning/gre" element={<TunnelGre />} />
                <Route path="/admin/provisioning/onu" element={<OnuProvisioning />} />
                <Route path="/admin/hermes/dashboard" element={<HermesDashboard />} />
                <Route path="/admin/hermes/service" element={<BackupService />} />
                <Route path="/admin/license" element={<License />} />
                <Route path="/admin/backup" element={<Backup />} />
                <Route path="/admin/hermes/queue" element={<Queue />} />
                {/* <Route path="/admin/hermes/error" element={<ErrorBackup />} /> */}
                <Route path="/admin/hermes/host" element={<Host />} />
                <Route path="/admin/hermes/config" element={<Config />} />
                <Route path="/admin/hermes/log_backup" element={<LogBackup />} />
                <Route path="/admin/hermes/topology" element={<TopologyPage />} />
                <Route path="/admin/hermes/snapshot" element={<SnapshotPage />} />
                <Route path="/admin/hermes/snapshot/sessao/:id" element={<SessaoPage />} />
                <Route path="/admin/hermes/grupos" element={<GruposHosts />} />
                <Route path="/admin/hermes/snapshot/comandos" element={<CatalogoComandos />} />
                <Route path="/admin/hermes/snapshot/fila" element={<FilaSnapshot />} />
                <Route path="/admin/service" element={<Services />} />
                <Route path="/admin/user/profile" element={<Profile />} />
                <Route path="/admin/profile/security" element={<SecuritySettings />} />
                <Route path="/admin/troubleshooting" element={<TroubleshootingSimple />} />
                
                
                <Route path="*" element={<NotFound />} />
                <Route path="403" element={<NotAuthorized />} />

            </Route>
        </>
    )
}